(function () {

    'use strict';

    angular.module('iplusjs.log', [
        'lodash',
        'iplusjs.config'
    ])
    .config(config);

    config.$inject = [
        '$provide'
    ];

    function config($provide) {
        $provide.decorator('$log', logDecorator);

        logDecorator.$inject = [
            '$delegate',
            'AppConfig',
            'lodash'
        ];

        function logDecorator($delegate, AppConfig, _) {
            var _loggingFns = {
                log: $delegate.log,
                info: $delegate.info,
                error: $delegate.error
            };

            _.forOwn(_loggingFns, function (logFn, key) {
                $delegate[key] = function () {
                    var args = [].slice.call(arguments),
                        enabled = AppConfig.APP.logging[key + 'Enabled'];

                    if (enabled) {
                        logFn.apply(null, args);
                    }
                };
            });

            return $delegate;
        }
    }
})();
